<script>
import { ref, onMounted, toRefs, watch, computed, reactive } from "vue";
import { useScrollEffect } from "../functions";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop"],
	setup(props) {
		const { windowWidth, windowHeight, scrollTop } = toRefs(props);

		const container = ref(null);
		const mainTitle = ref(null);
		const cover = ref(null);
		const text = ref(null);

		const containerHeight = ref(0);
		const imgSrc = reactive({
			pc: require("../assets/launchImg/background_c5.jpg"),
			mobile: require("../assets/launchImg/background_c5_mobile.png"),
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});

		const containerCoeff = useScrollEffect(
			-100,
			1 * windowHeight.value,
			100,
			0
		);
		const smallTransfromCoeff = useScrollEffect(
			1.1 * windowHeight.value,
			3.5 * windowHeight.value,
			0,
			-60
		);
		const mainTitleCoeff = useScrollEffect(
			0.33 * windowHeight.value,
			windowHeight.value,
			-0.5,
			1.1
		);
		const coverCoeff = useScrollEffect(
			1.6 * windowHeight.value,
			2.2 * windowHeight.value,
			-1.1,
			1.1
		);
		const textCoeff = computed(() => {
			return useScrollEffect(
				2 * windowHeight.value,
				2.2 * windowHeight.value,
				-0.5,
				1.1
			);
		});

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
			});
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (
					innerHeight.value > -100 &&
					innerHeight.value < 1 * windowHeight.value
				) {
					container.value.style.backgroundPosition = `center calc(50%${
						windowWidth.value <= 650 ? " - 12vw" : ""
					} + ${nv * containerCoeff.a + containerCoeff.b}px)`;
				} else if (
					innerHeight.value > 1.1 * windowHeight.value &&
					innerHeight.value < 3.5 * windowHeight.value
				) {
					container.value.style.transform = `translateY(${nv *
						smallTransfromCoeff.a +
						smallTransfromCoeff.b}px)`;
				}

				if (innerHeight.value > 0.33 * windowHeight.value) {
					mainTitle.value.style.opacity = `${nv * mainTitleCoeff.a +
						mainTitleCoeff.b}`;
					if (windowWidth.value <= 650) {
						cover.value.style.opacity = `${nv * mainTitleCoeff.a +
							mainTitleCoeff.b}`;
					}
				} else if (innerHeight.value <= 0.33 * windowHeight.value) {
					mainTitle.value.style.opacity = 0;
					if (windowWidth.value <= 650) {
						cover.value.style.opacity = 0;
					}
				}

				if (innerHeight.value > 1.6 * windowHeight.value) {
					mainTitle.value.style.opacity = `${-nv * coverCoeff.a -
						coverCoeff.b}`;
					if (windowWidth.value > 650) {
						cover.value.style.opacity = `${nv * coverCoeff.a +
							coverCoeff.b}`;
					}
				}

				if (
					innerHeight.value > 2 * windowHeight.value &&
					innerHeight.value < 2.2 * windowHeight.value
				) {
					text.value.style.opacity = `${nv * textCoeff.value.a +
						textCoeff.value.b}`;
				} else if (innerHeight.value <= 2 * windowHeight.value) {
					text.value.style.opacity = 0;
				}
			}
		);
		return {
			container,
			windowWidth,
			imgSrc,
			cover,
			mainTitle,
			textCoeff,
			text,
		};
	},
};
</script>

<template>
	<section id="performance">
		<img
			:src="windowWidth > 650 ? imgSrc.pc : imgSrc.mobile"
			alt="G26全新BMW 4系列Gran Coupé豪華四門跑車 性能 BMW TwinPower Turbo 4缸汽油引擎 245匹最大馬力"
		/>
		<div
			class="bg_c5 sticky-wrapper"
			ref="container"
			:style="{
				backgroundImage: `url(${
					windowWidth > 650 ? imgSrc.pc : imgSrc.mobile
				})`,
			}"
		>
			<div class="contain-img"></div>
			<div class="main-cover" ref="mainTitle">
				<h2 class="title_main text_ch_medium shine">
					<span class="inner_title_main">極致駕馭 盡顯鋒</span>
					<span>采</span>
				</h2>
				<p class="title_sub text_ch_medium">
					<span>新一代高效引擎，搭配經完美調校的底盤和懸吊系統，</span
					><br />
					<span>
						造就動感且穩定的俐落身手，<br class="mobile_break" />
						帶來兼具酣暢與舒適的駕馭樂趣。
					</span>
				</p>
			</div>
			<div class="cover" ref="cover"></div>
		</div>
	</section>
	<section id="performance-text">
		<div class="sticky-wrapper" ref="text">
			<p class="text_minor text_en_light">PERFORMANCE</p>
			<h2 class="text_title text_ch_medium">
				<span class="text_en_bold">BMW TwinPower Turbo 4 </span>
				<span>缸汽油引擎</span>
			</h2>
			<p class="text_context text_ch_medium">
				<span
					>隨傳隨到的驚艷動力，創造出
					<span class="text_en_bold">245 </span>匹最大馬力，</span
				><br />
				<span>帶來酣暢淋漓的駕馭樂趣！</span>
			</p>
		</div>
	</section>
</template>

<style lang="sass" scoped>
#performance
    z-index: 56
    background-color: #111
    img
        display: none
    .bg_c5
        width: 100%
        background-size: cover
        background-repeat: no-repeat
        background-position: center calc(50% + 100px)
        // background-position: center calc(50% + 100px + 100.02vw - 509.2px)
        .contain-img
            display: none
            position: absolute
            width: 100%
            height: 35px
            bottom: -35px
            background-color: #111
            background-size: 100% 35px
            -webkit-background-size: 100% 35px
            -moz-background-size: 100% 35px
            -o-background-size: 100% 35px
            background-position: center bottom
            background-repeat: no-repeat
            z-index: 90
        .cover
            position: absolute
            width: 100%
            height: calc(100% + 60px)
            left: 0
            bottom: -5px
            opacity: 0
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 16%, rgba(0, 0, 0, 0.6) 80%, #111 97%)
        .main-cover
            position: relative
            width: 90%
            margin: 0 auto
            top: 70%
            z-index: 90
            text-align: center
            overflow: hidden
            h2
                position: relative
                width: 100vw
                left: 50%
                transform: translateX(-50%)
                text-align: center
                font-size: 3rem
                line-height: 2.83
                color: #999
                span
                    letter-spacing: normal
                    font-size: inherit
                    &.inner_title_main
                        letter-spacing: 15px
                &.shine
                        animation: shine 4s infinite linear forwards
            .title_sub
                position: relative
                margin-top: 10px
                font-size: 1.7rem
                line-height: 2.12
                letter-spacing: 3.06px
                text-align: center
                z-index: 70
                span
                    font-size: inherit
                .mobile_break
                    display: none

#performance-text
    z-index: 56
    .sticky-wrapper
        width: calc(100% - 4.6vw + 2.8px)
        padding-left: calc(4.6vw - 2.8px)
        opacity: 0
        .text_minor
            position: relative
            top: 43%
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25)
            font-size: 1.1rem
            line-height: 5
            letter-spacing: 0.83px
        .text_title
            position: relative
            top: 43%
            font-size: 3.2rem
            line-height: 1.25
            letter-spacing: 2.4px
            span
                font-size: inherit
        .text_context
            position: relative
            top: 43%
            margin-top: 20px
            font-size: 1.7rem
            line-height: 2.12
            letter-spacing: 2.04px
            span
                font-size: inherit
                &.text_en_bold
                    letter-spacing: 1.28px
            .mobile_break
                display: none

@media screen and (min-width: 1441px)
    #performance-text
        .sticky-wrapper
            .title_sub
                top: calc(50% + 12.7vw + 56.2px - 20px)
@media screen and (max-width: 1440px)
    #performance
        .bg_c5
            .main-cover
                // transform: scale(0.9)
    #performance-text
        .sticky-wrapper
            .title_sub
                transform: scale(0.9)
@media screen and (max-width: 1200px)
    #performance
        .bg_c5
            .title_main
                // transform: scale(1)
    #performance-text
        .sticky-wrapper
            .title_sub
                transform: scale(1)
@media screen and (max-width: 768px)
    #performance
        .bg_c5
            .main-cover
                .title_main
                    line-height: 2.22
                    span
                        font-size: 1.8rem
                        &.inner_title_main
                            letter-spacing: 10.8px
                .title_sub
                    font-size: 1.2rem
                    line-height: 2.08
                    letter-spacing: 1.44px
    #performance-text
        .sticky-wrapper
            width: calc(100% - 4.6vw - 22.8px)
            padding-left: calc(4.6vw + 22.8px)
            .text_minor
                font-size: 1rem
                letter-spacing: 1px
                color: #ddd
                transform: scale(0.8)
                transform-origin: left center
            .text_title
                font-size: 1.5rem
                line-height: 2.67
                letter-spacing: 1.13px
            .text_context
                font-size: 1.2rem
                line-height: 2.08
                letter-spacing: 1.44px
                span
                    &.text_en_bold
                        letter-spacing: 0.9px

@media screen and (max-width: 650px)
    #performance
        background-color: #111
        .bg_c5
            background-size: 100% auto
            // background-position: center calc(50% - 20px)
            background-position: center calc(50% - 12vw + 100px)
            .contain-img
                display: block
            .main-cover
                // top: calc(2.6vw + 300px + 52.7% - 367px)
                top: 68%
                .title_sub
                    margin: 0
                    .pc_break
                        display: none
                    .mobile_break
                        display: block
            .cover
                height: 55%
                background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #111 76%)
    #performance-text
        .sticky-wrapper
            .text_minor, .text_title, .text_context
                top: 68%
            .text_minor
                line-height: 1.5
            .text_context
                margin-top: 10px
@media screen and (max-height: 600px)
    #performance
        .bg_c5
            .main-cover
                top: 63%
    #performance-text
        .sticky-wrapper
            .text_minor, .text_title, .text_context
                top: 65%
</style>
